export enum EAuthTypes {
  ACCOUNT = "ACCOUNT",
  BASIC = "BASIC",
  OAUTH2 = "OAUTH2",
  TOKEN = "TOKEN",
  REQUEST = "REQUEST",
}
